import { ConfigProvider } from 'antd';
import 'antd/dist/antd.less';
import ptBr from 'antd/es/locale/pt_BR';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import App from './App';
import GlobalStyle from './components/_settings/GlobalStyle';
import { AnalyticsProvider } from './services/analytics';
import * as serviceWorker from './serviceWorker';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <GlobalStyle />
    <ConfigProvider locale={ptBr}>
      <ThemeProvider theme={theme}>
        <AnalyticsProvider>
          <App />
        </AnalyticsProvider>
      </ThemeProvider>
    </ConfigProvider>
  </>
);

serviceWorker.unregister();
